import { Spin } from "antd";

import "./App.css";
import Router from "./Router.js";
// import Footer from "./components/footer/index";
import logo from "./assets/img/logo/colagio-logo-warna-tulisan-putih.png";
import React from "react";

function App() {
  return (
    <React.Fragment>
      {!logo ? (
        <Spin />
      ) : (
        <React.Fragment>
          <Router />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default App;
